import type { Dollars } from 'models/dollars';

/*
  A simple function to remove degenerate prices and round to the next price that makes sense.
  It guarantees prices are always between 1 and 99.
  This function is used to guarantee which sync our graphs with the degenerate prices we have on
  the stats history api.
 */
export const isValidPrice = (priceInCents?: number): boolean => {
    return !!priceInCents && 0 < priceInCents && priceInCents < 100;
};

export const isValidPriceDollars = (priceDollars?: Dollars): boolean => {
    return !!priceDollars && priceDollars.gt(0) && priceDollars.lt(1);
};

export const closestValidPrice = (priceInCents: number): number => {
    return Math.max(Math.min(priceInCents, 99), 1);
};

export const calculateSpread = (yesBid: number, yesAsk: number): number => {
    return Math.abs(yesAsk - yesBid);
};
